// Import project components
import { dialog } from "./scripts/dialog";
import { avatar } from "./scripts/avatar";
import { quickNavigation } from "./scripts/quickNavigation";
import { notification } from "./scripts/notification";
import { checkboxTabs } from "./scripts/checkboxTabs";
import { inviteLink } from "./scripts/inviteLink";
import { form } from "./scripts/form";
import { share } from "./scripts/share";
import { readMore } from "./scripts/readMore";
import { addSvgToDom } from "./scripts/addSvgToDom";
import { tree } from "./scripts/tree";
import { touchEffect } from "./scripts/touchEffect";
import { datePicker } from "./scripts/datePicker";
import { datePickerInQuestion } from "./scripts/datePickerInQuestion";
import { sendOffers } from "./scripts/sendOffers";
import { inputBank } from "./scripts/inputBank";
import { inputZip } from "./scripts/inputZip";
import { dependendFields } from "./scripts/dependendFields";
import { offers } from "./scripts/offers";
import { dropdownMenu } from "./scripts/dropdownMenu";
import { distanceCalculation } from "./scripts/distanceCalculation";
import { trackingHotjar } from "./scripts/trackingHotjar";
import { backlinkValue } from "./scripts/backlinkValue";
import { inviteText } from "./scripts/inviteText";
import { formInfoBox } from "./scripts/formInfoBox";
import { otpVerification } from "./scripts/otpVerification";
import { dialogBuyerRegistration } from "./scripts/dialogBuyerRegistration";
import { commissionButton } from "./scripts/commissionButton";
import { confirmation } from "./scripts/confirmation";
import { checkboxButton } from "./scripts/checkboxButton";

// Invoke functions from modules:
dialog();
avatar();
quickNavigation();
form();
notification();
checkboxTabs();
inviteLink();
share();
readMore();
addSvgToDom();
tree();
touchEffect();
datePicker();
datePickerInQuestion();
sendOffers();
inputBank();
inputZip();
dependendFields();
offers();
dropdownMenu();
distanceCalculation();
trackingHotjar();
backlinkValue();
inviteText();
formInfoBox();
otpVerification();
dialogBuyerRegistration();
commissionButton();
checkboxButton();
confirmation();
